import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/components/Layout/index.vue'),
    // ========== 临时需求 - 本地内定抽奖(lotteryType=10) 根路径直接进特殊内定栏目 ==========
    redirect: () => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return Number(userInfo.lotteryType) === 10 ? '/special-fixed' : '/dashboard'
    },
    // ========== 临时需求结束 ==========
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'prizes',
        name: 'Prizes',
        component: () => import('@/views/prizes/index.vue'),
        meta: { title: '奖项管理', icon: 'el-icon-gift' }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/users/index.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'participants',
        name: 'Participants',
        component: () => import('@/views/participants/index.vue'),
        meta: { title: '用户参与', icon: 'el-icon-s-custom' }
      },
      {
        path: 'records',
        name: 'Records',
        component: () => import('@/views/records/index.vue'),
        meta: { title: '中奖记录', icon: 'el-icon-trophy' }
      },
      {
        path: 'codes',
        name: 'Codes',
        component: () => import('@/views/codes/index.vue'),
        meta: { title: '兑换码管理', icon: 'el-icon-key' }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/products/index.vue'),
        meta: { title: '商品管理', icon: 'el-icon-goods' }
      },
      {
        path: 'mall-users',
        name: 'MallUsers',
        component: () => import('@/views/mall-users/index.vue'),
        meta: { title: '积分商城用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'exchange-records',
        name: 'ExchangeRecords',
        component: () => import('@/views/exchange-records/index.vue'),
        meta: { title: '用户兑换记录', icon: 'el-icon-document' }
      },
      {
          path: 'admins',
          name: 'Admins',
          component: () => import('@/views/admins/index.vue'),
          meta: { title: '子账号管理', icon: 'el-icon-user-solid' }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import('@/views/settings/index.vue'),
          meta: { title: '系统设置', icon: 'el-icon-setting' }
        },

        {
          path: 'fixed-phones',
          name: 'FixedPhones',
          component: () => import('@/views/fixed-phones/index.vue'),
          meta: { title: '内定人员', icon: 'el-icon-mobile' }
        },

        {
          path: 'verify-users',
          name: 'VerifyUsers',
          component: () => import('@/views/verify-users/index.vue'),
          meta: { title: '核销员管理', icon: 'el-icon-user' }
        },
        {
          path: 'questionnaires',
          name: 'Questionnaires',
          component: () => import('@/views/questionnaires/index.vue'),
          meta: { title: '问卷管理', icon: 'el-icon-edit' }
        },
        {
          path: 'questionnaire-records',
          name: 'QuestionnaireRecords',
          component: () => import('@/views/questionnaire-records/index.vue'),
          meta: { title: '问卷记录', icon: 'el-icon-document' }
        },
        {
          path: 'questionnaire-statistics',
          name: 'QuestionnaireStatistics',
          component: () => import('@/views/questionnaire-statistics/index.vue'),
          meta: { title: '问卷汇总', icon: 'el-icon-pie-chart' }
        },
        {
          path: 'limited-users',
          name: 'LimitedUsers',
          component: () => import('@/views/limited-users/index.vue'),
          meta: { title: '可参与人员名单', icon: 'el-icon-user', isSubAdmin: true }
        },
        {
          path: 'reset-test-data',
          name: 'ResetTestData',
          component: () => import('@/views/reset-test-data/index.vue'),
          meta: { title: '清除测试数据', icon: 'el-icon-delete', isSubAdmin: true }
        },
        {
          path: 'reports',
          name: 'Reports',
          component: () => import('@/views/reports/index.vue'),
          meta: { title: '举报管理', icon: 'el-icon-warning' }
        },
        {
          path: 'template-cases',
          name: 'TemplateCases',
          component: () => import('@/views/template-cases/index.vue'),
          meta: { title: '模板案例', icon: 'el-icon-picture-outline' }
        },
        {
          path: 'announcements',
          name: 'Announcements',
          component: () => import('@/views/announcements/index.vue'),
          meta: { title: '公告管理', icon: 'el-icon-bell', isTemp: true }
        },
        {
          path: 'paid-components',
          name: 'PaidComponents',
          component: () => import('@/views/paid-components/index.vue'),
          meta: { title: '付费组件', icon: 'el-icon-money' }
        },
        // ========== 临时需求 - 资料管理 ==========
        {
          path: 'linshi-material',
          name: 'LinshiMaterial',
          component: () => import('@/views/linshi-material/index.vue'),
          meta: { title: '资料管理', icon: 'el-icon-folder-opened', isLinshi: true }
        },
        // ========== 临时需求结束 ==========
        // ========== 临时需求 - 线上营销管理 ==========
        {
          path: 'marketing',
          name: 'Marketing',
          component: () => import('@/views/marketing/index.vue'),
          meta: { title: '线上营销管理', icon: 'el-icon-s-marketing', isMarketing: true }
        },
        // ========== 临时需求结束 ==========
        // ========== 临时需求 - SWJG8947UDNB 特殊内定栏目 ==========
        {
          path: 'special-fixed',
          name: 'SpecialFixed',
          component: () => import('@/views/special-fixed/index.vue'),
          meta: { title: '特殊内定栏目', icon: 'el-icon-star-on', isSpecial: true }
        },
        // ========== 临时需求结束 ==========
        {
          path: 'compress-codes',
          name: 'CompressCodes',
          component: () => import('@/views/compress-codes/index.vue'),
          meta: { title: '压缩兑换码管理', icon: 'el-icon-key', isMainAdmin: true }
        }
    ]
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/admin/',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    if (token) {
      // ========== 临时需求 - 本地内定抽奖(lotteryType=10) 登录后直接进特殊内定栏目 ==========
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      next(Number(userInfo.lotteryType) === 10 ? '/special-fixed' : '/dashboard')
      // ========== 临时需求结束 ==========
    } else {
      next()
    }
  } else {
    if (token) {
      // isTemp 标识的页面（公告管理）只允许主账号访问
      if (to.meta.isTemp) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        if (userInfo.isadmin !== 1) {
          next('/dashboard')
          return
        }
      }
      // isMainAdmin 标识的页面（压缩兑换码管理）只允许主账号访问
      if (to.meta.isMainAdmin) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        if (userInfo.isadmin !== 1) {
          next('/dashboard')
          return
        }
      }
      next()
    } else {
      next('/login')
    }
  }
})

export default router
